// file for handling the top filters.
//Import Libraries
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { config } from "../../../config/config";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import { InputLabel } from "@material-ui/core";
import "./templateview.scss";
import Loader from "../../../components/Loader/Loader";
import FileUpload from "../../../components/FileUpload/FileUpload";
import GlobalDropZone from "../../../components/FileUpload/GlobalDropZone";
import { useUserAuthentication } from "../../../utils/utils";
import Popover from "@mui/material/Popover";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;

function MetaSearchFilter(props) {
  let {
    user,
    source_data,
    updateSourceInputs,
    loading,
    setMappedData,
    updateAlert,
    setMappedDataCreateNew,
    setMappedDataForExistingTemplate,
    isPlaceholderFetching,
  } = props;
  const [expand, setExpand] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isSffLoading, setIsSffLoading] = useState(false);
  const [isTemplateSffLoading, setIsTemplateSffLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  let history = useHistory();

  const open = Boolean(anchorEl);
  const { login } = useUserAuthentication();

  const isCreateNewVisible = useMemo(() => {
    if (
      source_data.current_filter_value === "Create new" &&
      source_data.current_filter_value !== ""
    ) {
      return false;
    }
    return (
      source_data.current_target_gold_layer === "" ||
      isFilterLoading == true ||
      isButtonLoading == true
    );
  }, [
    source_data,
    source_data.current_target_gold_layer,
    source_data.current_filter_value,
    isFilterLoading,
    isButtonLoading,
  ]);

  const isExistingVisible = useMemo(() => {
    if (
      source_data.current_filter_value === "Existing" &&
      source_data.current_filter_value !== ""
    ) {
      return false;
    }
    return (
      source_data.current_target_gold_layer == "" ||
      isFilterLoading == true ||
      isButtonLoading == true
    );
  }, [
    source_data,
    source_data.current_target_gold_layer,
    source_data.current_filter_value,
    isFilterLoading,
    isButtonLoading,
  ]);

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  const has_Awaiting_Data = useMemo(() => {
    const data = source_data?.has_awaiting_data;

    if (!data) return false;

    const { has_records, has_access } = data;

    return !has_records || (has_records && has_access);
  }, [source_data.has_awaiting_data]);

  let result = [];
  let sourceOptions = [];
  let SSF_FILE_options = [];

  // FETCH META DATA FOR SELECTED DATASET
  const handleSourceChange = async (e, selectedOption) => {
    updateSourceInputs("current_source", selectedOption.value);
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_ssfFileId", "");

    const Target_gold_layer = source_data.data.data.find((item) => {
      return item.dataset_name === selectedOption.value;
    });
    updateSourceInputs(
      "current_target_gold_layer_list",
      Target_gold_layer.TARGET_GOLD_LAYER,
    );
  };

  const handleTargetGoldLayerChange = async (e, selectedOption) => {
    updateSourceInputs("current_target_gold_layer", selectedOption);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);

    const params = new URLSearchParams({
      dataset_name: selectedOption?.value || "",
    });

    try {
      // code for initial data fetching
      const response = await fetch(
        api + `/gold_template_mapping/getmetadata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const responseJson = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (responseJson?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }
      const Data = responseJson.data;

      const SourceData = {
        ...source_data.data,
        dropdown: {
          ...Data,
        },
      };

      updateSourceInputs("current_mapped_country", []);
      updateSourceInputs("data", SourceData);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }
  };

  // FETCH COUNTRIES FOR CHOSEN FILTER TYPE
  const handleRadioChange = async (e) => {
    setIsFilterLoading(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_filter_value", e.target.value);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_template_ssf_file_id", []);

    const params = new URLSearchParams({
      filter_type: e.target.value === "Existing" ? "existing" : "create",
      dataset_name: source_data?.current_target_gold_layer?.value || "",
      gold_layer: source_data?.current_target_gold_layer?.label || "",
    });
    try {
      const response = await fetch(
        api + `/gold_template_mapping/getcountries?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const NEW_COUNTRIES = data?.data || [];

      const countryOptions = NEW_COUNTRIES?.filter(
        (country) =>
          country !== null && country !== undefined && country !== "",
      )
        ?.filter((item) => item != null) // filters out null and undefined
        .map((country) => ({
          label: country,
          value: country,
        }));

      updateSourceInputs("current_mapped_country", countryOptions);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsFilterLoading(false);
  };

  // FETCH SFF_FILE_ID'S FOR SELECTED COUNTRY
  const handleCountryChange = async (e, selectedOption) => {
    setIsSffLoading(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_template_ssf_file_id", []);

    // API call to get Updated SFF_File_Id based on Filter
    const params = new URLSearchParams({
      country: selectedOption.label || "",
      type:
        source_data.current_filter_value === "Existing" ? "existing" : "create",
      dataset_name: source_data?.current_target_gold_layer?.value || "",
      target_gold_layer: source_data?.current_target_gold_layer?.label || "",
    });
    try {
      const response = await fetch(
        api + `/gold_template_mapping/get_harbor_source_file_id?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const NEW_SFF_FILE_IDS = data?.data || [];

      const UPDATED_NEW_SFF_FILE_IDS =
        Array.isArray(NEW_SFF_FILE_IDS) &&
        NEW_SFF_FILE_IDS.length === 1 &&
        NEW_SFF_FILE_IDS[0] === ""
          ? []
          : NEW_SFF_FILE_IDS?.filter(
              (fileid) =>
                fileid !== null && fileid !== undefined && fileid !== "",
            )?.map((item) => {
              return { label: item, value: item };
            });

      updateSourceInputs("current_ssf_file_id", UPDATED_NEW_SFF_FILE_IDS);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    updateSourceInputs("current_country", selectedOption.label);
    updateSourceInputs("current_country_code", selectedOption.value);
    updateSourceInputs("current_mapped_data", []);
    setIsSffLoading(false);
  };

  // FETCH TABLE DATA FOR SELECTED SFF_FILE_ID
  const handleSSFFileChange = async (e, selectedOption) => {
    setIsButtonLoading(false);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("current_ssfFileId", selectedOption.value);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("is_file_uploaded", false);

    // fetch PLACEHOLDER_DATA if "Create new" is selected
    const Country_Code = source_data.master_table_countries.find(
      (item) =>
        item.label.toUpperCase() === source_data.current_country ||
        item.value.toUpperCase() === source_data.current_country_code,
    );

    if (source_data.current_filter_value !== "Create new") {
      setMappedData(
        source_data.current_target_gold_layer.value,
        source_data.current_country,
        Country_Code ? Country_Code.value : source_data.current_country,
        selectedOption.value,
        source_data.current_filter_value,
        "initial",
        source_data.current_target_gold_layer.label,
      );
    } else {
      setMappedDataCreateNew(
        source_data.current_target_gold_layer.value,
        source_data.current_country,
        Country_Code ? Country_Code.value : source_data.current_country,
        selectedOption.value,
        "initial",
        source_data.current_target_gold_layer.label,
      );
    }
  };

  //for getting the dataset name from redux and map it into array.
  if (source_data.data && source_data?.data?.data) {
    result =
      source_data?.data?.data &&
      source_data?.data?.data.map((data) => {
        return data.toString();
      });

    sourceOptions =
      result &&
      result.map((data) => {
        return { label: data, value: data };
      });
  }

  // GET PLACEHOLDER DATA FOR SELECTED SFF_FILE_ID - ONLY FOR CREATE NEW FILTER
  const handlePlaceholderFile = async () => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", false);
  };

  const handleExistingTemplate = async (event) => {
    updateSourceInputs("current_template_ssf_file_id", []);
    const anchor = event.currentTarget;
    setAnchorEl(anchor);
    setIsTemplateSffLoading(true);
    // API call to get Template SFF_File_Id based on Filter
    const params = new URLSearchParams({
      country: source_data.current_country || "",
      type: "existing",
      dataset_name: source_data?.current_target_gold_layer?.value || "",
      target_gold_layer: source_data?.current_target_gold_layer?.label || "",
    });
    try {
      const response = await fetch(
        api + `/gold_template_mapping/get_harbor_source_file_id?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const NEW_SFF_FILE_IDS = data?.data || [];

      const UPDATED_NEW_SFF_FILE_IDS =
        Array.isArray(NEW_SFF_FILE_IDS) &&
        NEW_SFF_FILE_IDS.length === 1 &&
        NEW_SFF_FILE_IDS[0] === ""
          ? []
          : NEW_SFF_FILE_IDS?.filter(
              (fileid) =>
                fileid !== null && fileid !== undefined && fileid !== "",
            )?.map((item) => {
              return { label: item, value: item };
            });

      updateSourceInputs(
        "current_template_ssf_file_id",
        UPDATED_NEW_SFF_FILE_IDS,
      );
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }
    setIsTemplateSffLoading(false);
  };

  // FETCH TABLE DATA FOR SELECTED SFF_FILE_ID
  const handleSSFFileChangeAfterTemplate = async (e, selectedOption) => {
    setAnchorEl(null);
    setIsButtonLoading(false);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("current_template_ssfFileId", selectedOption.value);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);

    // fetch PLACEHOLDER_DATA if "Create new" is selected
    const Country_Code = source_data.master_table_countries.find(
      (item) =>
        item.label.toUpperCase() === source_data.current_country ||
        item.value.toUpperCase() === source_data.current_country_code,
    );

    await setMappedDataForExistingTemplate(
      source_data.current_target_gold_layer.value,
      source_data.current_country,
      Country_Code ? Country_Code.value : source_data.current_country,
      selectedOption.value,
      "default",
      source_data.current_target_gold_layer.label,
    );
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {/* <div className="cnc-toggle-icon">
        <label
          onClick={() => {
            setExpand(!expand);
          }}
        >
          {!expand ? "Collapse" : "Expand"}
        </label>
        <i
          className="material-icons"
          onClick={() => {
            setExpand(!expand);
          }}
        >
          {!expand ? "keyboard_arrow_up" : "keyboard_arrow_down"}
        </i>
      </div> */}

      {!expand && (
        <div className="cnc-model-header-mapping">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)", // 5 equal-width columns
              gridTemplateRows: "1fr", // 1 row
              gap: "12px", // gap between columns (and rows if any)
              padding: "2px 15px 0px 15px",
              width: "100%",
            }}
          >
            <>
              {/* DATASETS */}
              <div item xs={2} sm={2}>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Dataset:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data.current_mapped_source}
                    loading={
                      loading &&
                      (source_data.current_mapped_source ||
                        source_data.current_mapped_source.length === 0)
                    }
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleSourceChange}
                    value={
                      source_data.current_source &&
                      source_data.current_source.length > 0
                        ? {
                            label: source_data.current_source,
                            value: source_data.current_source,
                          }
                        : null
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_source === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#fff",
                        fontFamily: "Hind Siliguri",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#333",
                        height: "36px",
                        paddingRight: "36px", // space for dropdown icon
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiAutocomplete-endAdornment": {
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)", // vertical center alignment
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#999",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>

              {/* TARGET GOLD LAYER */}
              <div>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Target Gold Layer:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data.current_target_gold_layer_list}
                    loading={
                      loading &&
                      (source_data.current_target_gold_layer_list ||
                        source_data.current_target_gold_layer_list.length === 0)
                    }
                    disabled={
                      !source_data.current_source ||
                      source_data.current_source.length === 0
                    }
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleTargetGoldLayerChange}
                    value={
                      source_data.current_target_gold_layer &&
                      Object.keys(source_data.current_target_gold_layer)
                        .length > 0
                        ? source_data.current_target_gold_layer
                        : null
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_source === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          source_data.current_source === ""
                            ? "#d6d6d6"
                            : "#fff",
                        fontFamily: "Hind Siliguri",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#333",
                        height: "36px",
                        paddingRight: "36px", // space for dropdown icon
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiAutocomplete-endAdornment": {
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)", // vertical center alignment
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#999",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>

              {/* FILTERS - CREATE NEW OR EXISTING */}
              <div>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Choose Filter:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div
                  className="radio-input-container"
                  style={{ marginBottom: "15px" }}
                >
                  {/* Insert New */}
                  <div className="radio-input-div">
                    <input
                      id="all-checkbox"
                      type="radio"
                      value="Create new"
                      disabled={isCreateNewVisible ? true : false}
                      name="filter"
                      checked={
                        source_data.current_filter_value === "Create new"
                      }
                      onChange={handleRadioChange}
                      className="radio-checkbox-label"
                    />
                    <InputLabel
                      htmlFor={"all-checkbox"}
                      className="radio-checkbox-label"
                    >
                      Create new
                    </InputLabel>
                  </div>

                  {/* Existing */}
                  <div className="radio-input-div">
                    <input
                      id="Unmapped-checkbox"
                      type="radio"
                      value="Existing"
                      disabled={isExistingVisible ? true : false}
                      name="filter"
                      checked={source_data.current_filter_value === "Existing"}
                      onChange={handleRadioChange}
                      className="radio-checkbox-label"
                    />
                    <InputLabel
                      htmlFor={"Unmapped-checkbox"}
                      className="radio-checkbox-label"
                    >
                      Existing
                    </InputLabel>
                  </div>
                </div>
              </div>

              {isFilterLoading && <Loader />}

              {/* COUNTRY */}
              {source_data.current_filter_value !== "" &&
                !isFilterLoading &&
                (source_data.current_mapped_country.length > 0 ? (
                  <div>
                    <div
                      className="mg-model-header-item"
                      style={{ height: "25px" }}
                    >
                      Select Country Code:{" "}
                      <p
                        style={{
                          display: "inline",
                          color: "red",
                          fontSize: 16,
                        }}
                      >
                        *
                      </p>
                    </div>
                    <div className="" style={{ marginBottom: "15px" }}>
                      <Autocomplete
                        disabled={
                          source_data.current_source === "" || loading == true
                            ? true
                            : false
                        }
                        id="country-select"
                        disableClearable
                        size="small"
                        options={source_data.current_mapped_country}
                        getOptionLabel={(option) => option.label}
                        onChange={handleCountryChange}
                        defaultValue={
                          {
                            label: source_data.current_country,
                            value: source_data.current_country_code,
                          } || null
                        }
                        popupIcon={
                          <span
                            className="material-icons"
                            style={{
                              fontSize: "20px",
                              color:
                                source_data.current_source === ""
                                  ? "f7f7f7"
                                  : "#555",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        }
                        sx={{
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#fff",
                            fontFamily: "Hind Siliguri",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "#333",
                            height: "36px",
                            paddingRight: "36px", // space for dropdown icon
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "8px 12px",
                          },
                          "& .MuiAutocomplete-endAdornment": {
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)", // vertical center alignment
                          },
                          "& .MuiSvgIcon-root": {
                            color: "#999",
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            // label="Select Country"
                            InputLabelProps={{
                              style: {
                                fontSize: "13px",
                              },
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            style={{
                              fontSize: "12px",
                              fontWeight: "normal",
                              color: "#212529",
                            }}
                          >
                            {option.label}
                          </li>
                        )}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="no_data_found">No Data Found</div>
                ))}

              {isSffLoading && <Loader />}

              {/* SFF FILE ID  */}
              {source_data.current_country !== "" &&
                !isSffLoading &&
                (source_data.current_ssf_file_id.length > 0 ? (
                  <div>
                    <div
                      className="mg-model-header-item"
                      style={{ height: "25px" }}
                    >
                      Select SFF File ID:{" "}
                      <p
                        style={{
                          display: "inline",
                          color: "red",
                          fontSize: 16,
                        }}
                      >
                        *
                      </p>
                    </div>
                    <div className="" style={{ marginBottom: "15px" }}>
                      <Autocomplete
                        id="country-select"
                        disableClearable
                        size="small"
                        options={source_data.current_ssf_file_id}
                        loading={
                          loading &&
                          (source_data.current_ssf_file_id ||
                            source_data.current_ssf_file_id.length === 0)
                        }
                        disabled={
                          !source_data.current_country ||
                          source_data.current_country.length === 0
                        }
                        loadingText={<Loader />}
                        getOptionLabel={(option) => option.label}
                        onChange={handleSSFFileChange}
                        value={
                          source_data.current_ssfFileId &&
                          source_data.current_ssfFileId.length > 0
                            ? {
                                label: source_data.current_ssfFileId,
                                value: source_data.current_ssfFileId,
                              }
                            : null
                        }
                        popupIcon={
                          <span
                            className="material-icons"
                            style={{
                              fontSize: "20px",
                              color:
                                source_data.current_country === ""
                                  ? "f7f7f7"
                                  : "#555",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        }
                        sx={{
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor:
                              source_data.current_country === ""
                                ? "#d6d6d6"
                                : "#fff",
                            fontFamily: "Hind Siliguri",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "#333",
                            height: "36px",
                            paddingRight: "36px", // space for dropdown icon
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "8px 12px",
                          },
                          "& .MuiAutocomplete-endAdornment": {
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)", // vertical center alignment
                          },
                          "& .MuiSvgIcon-root": {
                            color: "#999",
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            // label="Select Country"
                            InputLabelProps={{
                              style: {
                                fontSize: "13px",
                              },
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            style={{
                              fontSize: "12px",
                              fontWeight: "normal",
                              color: "#212529",
                            }}
                          >
                            {option.label}
                          </li>
                        )}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="no_data_found">No Data Found</div>
                ))}
            </>
          </div>
        </div>
      )}

      {isPlaceholderFetching && <Loader />}

      {/* FILE UPLOAD OR PLACEHOLDER SELECTION */}
      {!expand &&
        !isPlaceholderFetching &&
        !props.isFileUploading &&
        source_data.is_initial &&
        source_data.is_table_loading &&
        has_Awaiting_Data && (
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            {source_data.current_ssfFileId !== "" && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "15px" }}
              >
                <div>
                  <GlobalDropZone
                    updateAlert={updateAlert}
                    handleFileUpload={props.handleFileUpload}
                    requiredColumns={
                      source_data?.data?.dropdown?.insert_column_attributes ||
                      []
                    }
                  />
                  <FileUpload
                    updateAlert={updateAlert}
                    handleFileUpload={props.handleFileUpload}
                    isFileUploading={props.isFileUploading}
                    requiredColumns={
                      source_data?.data?.dropdown?.download_sample_columns || []
                    }
                    source_Data={source_data}
                    updateSourceInputs={updateSourceInputs}
                    user={user}
                  />
                </div>
                <span>Or</span>
                <button
                  onClick={handlePlaceholderFile}
                  className="sample-button"
                  // disabled={source_data.is_table_loading}
                >
                  Proceed with Existing Template
                </button>

                {source_data.current_filter_value === "Create new" && (
                  <>
                    <span>Or</span>
                    <button
                      onClick={handleExistingTemplate}
                      className="sample-button"
                      // disabled={source_data.is_table_loading}
                    >
                      Proceed with Reusable Template
                    </button>
                  </>
                )}
                <Popover
                  id={"reusable-template"}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <div className="reuse-popover-container">
                    {isTemplateSffLoading && <Loader />}

                    <>
                      {source_data.current_template_ssf_file_id.length > 0 ? (
                        <div>
                          <div
                            className="mg-model-header-item"
                            style={{ height: "25px" }}
                          >
                            Select SFF File id (Reuse) :{" "}
                            <p
                              style={{
                                display: "inline",
                                color: "red",
                                fontSize: 16,
                              }}
                            >
                              *
                            </p>
                          </div>
                          <div className="" style={{ marginBottom: "15px" }}>
                            <Autocomplete
                              id="country-select"
                              disableClearable
                              size="large"
                              options={
                                source_data?.current_template_ssf_file_id || []
                              }
                              loading={isTemplateSffLoading}
                              disabled={false}
                              loadingText={<Loader />}
                              getOptionLabel={(option) => option.label}
                              onChange={handleSSFFileChangeAfterTemplate}
                              value={
                                source_data.current_template_ssfFileId &&
                                source_data.current_template_ssfFileId !== ""
                                  ? {
                                      label:
                                        source_data.current_template_ssfFileId,
                                      value:
                                        source_data.current_template_ssfFileId,
                                    }
                                  : null
                              }
                              popupIcon={
                                <span
                                  className="material-icons"
                                  style={{
                                    fontSize: "20px",
                                    color: false ? "f7f7f7" : "#555",
                                  }}
                                >
                                  arrow_drop_down
                                </span>
                              }
                              sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: false ? "#d6d6d6" : "#fff",
                                  fontFamily: "Hind Siliguri",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  fontWeight: "400",
                                  color: "#333",
                                  height: "36px",
                                  paddingRight: "36px", // space for dropdown icon
                                },
                                "& .MuiOutlinedInput-input": {
                                  padding: "8px 12px",
                                },
                                "& .MuiAutocomplete-endAdornment": {
                                  right: "12px",
                                  top: "50%",
                                  transform: "translateY(-50%)", // vertical center alignment
                                },
                                "& .MuiSvgIcon-root": {
                                  color: "#999",
                                },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  // label="Select Country"
                                  InputLabelProps={{
                                    style: {
                                      fontSize: "13px",
                                    },
                                  }}
                                />
                              )}
                              renderOption={(props, option) => (
                                <li
                                  {...props}
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "normal",
                                    color: "#212529",
                                  }}
                                >
                                  {option.label}
                                </li>
                              )}
                            />
                          </div>
                        </div>
                      ) : (
                        !isTemplateSffLoading && (
                          <div className="no_data_found">No Data Found</div>
                        )
                      )}
                    </>
                  </div>
                </Popover>
              </div>
            )}
          </div>
        )}
    </>
  );
}

MetaSearchFilter.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  cncData: PropTypes.object,
  brand_data: PropTypes.object,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAlert,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetaSearchFilter),
);
